import React from 'react';

interface LogoProps {
  className?: string;
  width?: number | string;
  height?: number | string;
}

export const Logo: React.FC<LogoProps> = ({ className = '', width = '100%', height = '100%' }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 500 120" 
      width={width} 
      height={height}
      className={className}
    >
      <defs>
        <linearGradient id="boltGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#00E667" />
          <stop offset="100%" stopColor="#00B04F" />
        </linearGradient>
        <linearGradient id="textGrad" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#0F172A" />
          <stop offset="100%" stopColor="#334155" />
        </linearGradient>
        <style>
          {`
            .bolt {
              transform-origin: 35px 50px;
              animation: pulse 2s infinite ease-in-out;
            }
            .swoosh {
              stroke-dasharray: 400;
              stroke-dashoffset: 400;
              animation: draw 3s infinite ease-in-out;
            }
            .text-parking {
              font-family: 'Montserrat', 'Segoe UI', system-ui, sans-serif;
              font-weight: 800;
              font-size: 52px;
              fill: url(#textGrad);
            }
            .text-bolt {
              font-family: 'Montserrat', 'Segoe UI', system-ui, sans-serif;
              font-weight: 900;
              font-size: 52px;
              fill: url(#boltGrad);
              font-style: italic;
            }
            @keyframes pulse {
              0% { transform: scale(1); filter: drop-shadow(0 0 2px rgba(0,176,79,0.4)); }
              50% { transform: scale(1.05); filter: drop-shadow(0 0 10px rgba(0,176,79,0.8)); }
              100% { transform: scale(1); filter: drop-shadow(0 0 2px rgba(0,176,79,0.4)); }
            }
            @keyframes draw {
              0% { stroke-dashoffset: 400; }
              50% { stroke-dashoffset: 0; }
              100% { stroke-dashoffset: -400; }
            }
            .p-loop {
              stroke-dasharray: 200;
              stroke-dashoffset: 200;
              animation: drawLoop 2s forwards ease-out;
            }
            @keyframes drawLoop {
              to { stroke-dashoffset: 0; }
            }
          `}
        </style>
      </defs>

      {/* Logo Icon */}
      <g transform="translate(20, 15)">
        {/* P Loop */}
        <path 
          className="p-loop"
          d="M 35 10 L 60 10 C 85 10, 95 25, 95 40 C 95 55, 85 70, 60 70 L 25 70" 
          fill="none" 
          stroke="#0F172A" 
          strokeWidth="12"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        
        {/* Lightning Bolt (Stem of P) */}
        <path 
          className="bolt"
          d="M 45 0 L 15 55 L 35 55 L 20 100 L 60 40 L 35 40 Z" 
          fill="url(#boltGrad)" 
        />
      </g>

      {/* Text */}
      <text x="130" y="75">
        <tspan className="text-parking">PARKING</tspan>
        <tspan className="text-bolt">BOLT</tspan>
      </text>

      {/* Animated Swoosh */}
      <path 
        className="swoosh"
        d="M 130 90 Q 300 110 480 90" 
        fill="none" 
        stroke="url(#boltGrad)" 
        strokeWidth="4" 
        strokeLinecap="round"
      />
    </svg>
  );
};
